/**
 * A container identifier. This value must be unique across all containers.
 */
export type ContainerIdentifier = string | Symbol;
